/*
 * Speedy Food · «Chiedi info su questo prodotto» (brief del 24/09/2026).
 *
 * Ordine fisso: salva la richiesta, POI apre WhatsApp. Se il CRM non risponde
 * lo si dice chiaro e si offre comunque la chat con prodotto e URL, senza un
 * riferimento inventato. Il markup sta in snippets/product-info-modal.liquid.
 *
 * Eventi GA4 separati: sf_product_cta_clicked, sf_product_form_opened,
 * sf_product_info_requested, sf_product_wa_open_clicked. Il messaggio ricevuto
 * NON si traccia qui: lo registra il commerciale dal CRM.
 */
(function () {
  'use strict';
  var dlg = document.getElementById('pinfo');
  if (!dlg) return;
  var strings = (document.getElementById('pinfo-strings') || {}).dataset || {};
  var form = dlg.querySelector('[data-pinfo-form]');
  var done = dlg.querySelector('[data-pinfo-done]');
  var submitBtn = dlg.querySelector('[data-pinfo-submit]');
  var d = dlg.dataset;
  var requestId = null;
  var waUrl = null;
  var sending = false;

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function track(name, extra) {
    var p = { product_handle: d.handle, product_title: d.title };
    for (var k in extra || {}) p[k] = extra[k];
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, p);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, p));
    } catch (e) { /* il tracciamento non deve mai fermare il modulo */ }
  }

  // Attribuzione: la salva theme.js al primo atterraggio (sessionStorage sf_attr),
  // qui si legge anche l'URL corrente per chi arriva dritto dalla DPA.
  function attribution() {
    var out = {};
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];
    try { out = JSON.parse(sessionStorage.getItem('sf_attr') || '{}') || {}; } catch (e) { out = {}; }
    var q = new URLSearchParams(location.search);
    keys.forEach(function (k) { if (q.get(k)) out[k] = q.get(k); });
    return out;
  }

  function open(ev) {
    if (ev) ev.preventDefault();
    if (!requestId) requestId = uuid(); // lo stesso modulo, lo stesso id: niente doppioni
    track('sf_product_cta_clicked', { position: ev && ev.currentTarget && ev.currentTarget.getAttribute('data-pinfo-open') });
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    track('sf_product_form_opened');
    var first = form.querySelector('input[name="nome"]');
    if (first && !form.hidden) setTimeout(function () { first.focus(); }, 30);
  }

  function close() {
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }

  document.querySelectorAll('[data-pinfo-open]').forEach(function (b) { b.addEventListener('click', open); });
  dlg.querySelectorAll('[data-pinfo-close]').forEach(function (b) { b.addEventListener('click', close); });
  // Il fondo chiude solo se la pressione e' partita li': un trascinamento nato
  // dentro il modulo e finito sul fondo da' un click sul <dialog> e lo chiudeva.
  var pressedOnBackdrop = false;
  dlg.addEventListener('pointerdown', function (e) { pressedOnBackdrop = e.target === dlg; });
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg && pressedOnBackdrop) close();
    pressedOnBackdrop = false;
  });

  function showErr(name, on, text) {
    var el = form.querySelector('[data-err="' + name + '"]');
    if (!el) return;
    if (text) el.textContent = text;
    el.hidden = !on;
    var input = form.querySelector('[name="' + name + '"]');
    if (input && input.setAttribute) input.setAttribute('aria-invalid', on ? 'true' : 'false');
  }

  function phoneLooksValid(v) {
    var digits = v.replace(/[^\d+]/g, '');
    if (digits.indexOf('+') === 0) return /^\+\d{8,15}$/.test(digits);
    digits = digits.replace(/^00/, '');
    return /^\d{8,13}$/.test(digits);
  }

  function validate() {
    var ok = true;
    var nome = form.nome.value.trim();
    var wa = form.whatsapp.value.trim();
    var comune = form.comune.value.trim();
    var tipo = form.querySelector('input[name="tipo_locale"]:checked');
    showErr('nome', nome.length < 2); if (nome.length < 2) ok = false;
    showErr('whatsapp', !phoneLooksValid(wa)); if (!phoneLooksValid(wa)) ok = false;
    showErr('tipo_locale', !tipo); if (!tipo) ok = false;
    showErr('comune', comune.length < 2); if (comune.length < 2) ok = false;
    var attivita = form.nome_locale.value.trim();
    showErr('nome_locale', attivita.length < 2); if (attivita.length < 2) ok = false;
    var consenso = form.marketing_consent.checked;
    showErr('marketing_consent', !consenso); if (!consenso) ok = false;
    if (!ok) {
      var firstBad = form.querySelector('[aria-invalid="true"]') || (!tipo && form.querySelector('input[name="tipo_locale"]')) || (!consenso && form.marketing_consent);
      if (firstBad) firstBad.focus();
    }
    return ok;
  }

  function busy(on) {
    sending = on;
    submitBtn.disabled = on;
    submitBtn.querySelector('[data-label-idle]').hidden = on;
    submitBtn.querySelector('[data-label-busy]').hidden = !on;
  }

  function post(body, attempt) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 12000) : null;
    return fetch(d.endpoint, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined,
    }).then(function (res) {
      if (timer) clearTimeout(timer);
      return res.json().catch(function () { return {}; }).then(function (json) { return { status: res.status, json: json }; });
    }).catch(function (err) {
      if (timer) clearTimeout(timer);
      // una sola riprova, con lo STESSO request_id: il server non duplica
      if (attempt < 1) return new Promise(function (r) { setTimeout(r, 1200); }).then(function () { return post(body, attempt + 1); });
      throw err;
    });
  }

  // Link senza riferimento: solo per quando il CRM non ha registrato niente.
  function fallbackWa() {
    var text = 'Ciao Speedy Food, ho visto ' + d.title + ' sul vostro sito e vorrei maggiori informazioni per il mio locale. ' + d.url;
    return 'https://wa.me/393514409517?text=' + encodeURIComponent(text);
  }

  function showDone(saved, url) {
    waUrl = url;
    form.hidden = true;
    done.hidden = false;
    done.querySelector('[data-done-title]').textContent = saved ? strings.okTitle : strings.koTitle;
    done.querySelector('[data-done-text]').textContent = saved ? strings.okText : strings.koText;
    var a = done.querySelector('[data-pinfo-wa]');
    a.href = url;
    a.onclick = function () { track('sf_product_wa_open_clicked', { saved: saved, via: 'button' }); markOpened(); };
    // «Copia il messaggio» serve soprattutto su desktop, dove WhatsApp può non esserci
    var copy = done.querySelector('[data-pinfo-copy]');
    copy.hidden = !(navigator.clipboard && window.matchMedia('(hover: hover)').matches);
    a.focus();
  }

  function markOpened() {
    if (!requestId) return;
    try {
      var u = d.endpoint.replace(/\/?$/, '') + '/opened';
      var payload = JSON.stringify({ request_id: requestId });
      if (navigator.sendBeacon) navigator.sendBeacon(u, payload);
      else fetch(u, { method: 'POST', body: payload, keepalive: true });
    } catch (e) { /* non blocca */ }
  }

  done.querySelector('[data-pinfo-copy]').addEventListener('click', function () {
    var text = decodeURIComponent((waUrl || '').split('text=')[1] || '');
    navigator.clipboard.writeText(text).then(function () {
      done.querySelector('[data-pinfo-copied]').hidden = false;
    });
  });

  // Un errore sparisce appena la persona lo corregge, non al prossimo invio.
  form.addEventListener('change', function (e) {
    var n = e.target && e.target.name;
    if (n === 'marketing_consent' && e.target.checked) showErr('marketing_consent', false);
    if (n === 'tipo_locale') showErr('tipo_locale', false);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sending) return; // doppio clic
    showErr('form', false);
    if (!validate()) return;
    var tipo = form.querySelector('input[name="tipo_locale"]:checked');
    var consent = form.marketing_consent.checked;
    var body = Object.assign({
      request_id: requestId || (requestId = uuid()),
      handle: d.handle,
      variant_id: d.variant ? Number(d.variant) : null,
      locale: d.locale === 'en' ? 'en' : 'it',
      nome: form.nome.value.trim(),
      whatsapp: form.whatsapp.value.trim(),
      tipo_locale: tipo.value,
      comune: form.comune.value.trim(),
      nome_locale: form.nome_locale.value.trim(),
      privacy_version: d.privacyVersion,
      marketing_consent: consent,
      marketing_consent_text: dlg.querySelector('[data-pinfo-consent-text]').textContent.trim(),
      marketing_consent_version: d.marketingVersion,
      page_url: location.href.split('#')[0],
      hp: form.hp.value,
      prodotti_visti: window.sfViewed ? window.sfViewed.list() : [],
    }, attribution());
    if (window.sfViewed) window.sfViewed.identify(body.whatsapp, body.nome);

    busy(true);
    post(body, 0).then(function (r) {
      busy(false);
      if (r.status === 422 && r.json && r.json.errors) {
        Object.keys(r.json.errors).forEach(function (k) { showErr(k, true); });
        return;
      }
      if (r.json && r.json.ok && r.json.saved && r.json.wa_url) {
        track('sf_product_info_requested', { ref: r.json.ref });
        track('sf_product_wa_open_clicked', { saved: true, via: 'redirect' });
        markOpened();
        showDone(true, r.json.wa_url);
        // stessa scheda: niente popup da bloccare. Se WhatsApp non si apre,
        // resta la conferma con «Apri WhatsApp».
        location.href = r.json.wa_url;
        return;
      }
      if (r.json && r.json.wa_url) { showDone(false, r.json.wa_url); return; }
      if (r.json && r.json.ok && r.json.saved === false) { showDone(false, fallbackWa()); return; } // honeypot
      showErr('form', true, strings.errGeneric);
      if (r.status >= 500 || r.status === 0) showDone(false, fallbackWa());
    }).catch(function () {
      busy(false);
      showDone(false, fallbackWa());
    });
  });
})();
